import styles from "./BeaconMap.scss";

export const ACTIVITY_STATES = {
  RECORDING: 1,
  AUTO_PAUSED: 2,
  STOPPED: 3,
  FINISHED: 4,
  SAVED: 5,
  DISCARDED: 6,
  NOT_STARTED: 7,
  DISABLED: 8,
};

export const FINISH_STATES = [
  ACTIVITY_STATES.FINISHED,
  ACTIVITY_STATES.SAVED,
  ACTIVITY_STATES.DISCARDED,
  ACTIVITY_STATES.DISABLED,
];

export function isFinished(status: number): boolean {
  return FINISH_STATES.includes(status);
}

export function isRecording(status: number): boolean {
  return !isFinished(status) && status !== ACTIVITY_STATES.STOPPED;
}

// Mirrors the legacy Mapbox behavior in MapView.js.coffee#updateBeaconPath:
// - finished/saved/discarded/disabled → finish icon
// - stopped → static "paused" dot
// - everything else (recording, auto_paused, not_started) → pulsing "recording" dot
// AUTO_PAUSED is treated as active because it's a transient state during a live
// recording, not a user-initiated pause.
function getBlipClassName(status: number): string {
  if (FINISH_STATES.includes(status)) {
    return `${styles['beacon-blip']} ${styles['beacon-blip-finished']}`;
  }
  if (status === ACTIVITY_STATES.STOPPED) {
    return `${styles['beacon-blip']} ${styles['beacon-blip-paused']}`;
  }
  return `${styles['beacon-blip']} ${styles['beacon-blip-recording']}`;
}

export default getBlipClassName;
